export enum CookieCategoryTypes {
  STRICTLY_NECESSARY_COOKIES = 'C0001',
  PERFORMANCE_COOKIES = 'C0002',
  FUNCTIONAL_COOKIES = 'C0003',
  TARGETING_COOKIES = 'C0004',
  SOCIAL_MEDIA_COOKIES = 'C0005',
}
